module.exports = __webpack_public_path__ + "static/media/bio.bfc92269.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/bio/bio.jpg
// module id = 147
// module chunks = 0